/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

type Props = {
  thirdPartyOrgName: string;
  isUpswell?: boolean;
};

const styles = {
  container: () => css`
    margin-top: var(--cds-spacing-200);
  `,
};

const SponsoredByMessage = ({ thirdPartyOrgName, isUpswell }: Props) => {
  if (isUpswell) {
    return null;
  }

  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.container}>
      <FormattedMessage message={_t('Access provided by {thirdPartyOrgName}')} thirdPartyOrgName={thirdPartyOrgName} />
    </Typography2>
  );
};

export default SponsoredByMessage;
